import React from 'react';
import { Redirect } from 'react-router-dom';

export const AppsRedirect: React.FC = (): JSX.Element => <Redirect to="/apps" />;
